namespace Areas.Dialogs.Employee {
    "use strict";

    export class EmployeeDialog extends Areas.BaseDialog {
        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("Employee", closeHandler)
        }

        protected ok = (e: any) => {
            const grid = $("#EmployeeLookupGrid").dxDataGrid("instance");

            const data = grid.getSelectedRowsData()[0];
            this.close(DialogResult.Ok, data); 
        }
    }

    export function employeeSelected() {
        Areas.enableButton("EmployeeOkDialog");
    }

}